<template>

  <div>
    <el-form
      class="login-form"
      :label-position="useDesignV2 ? 'top' : 'right'"
      :model="model"
      :rules="rules"
      ref="form"
      @submit.native.prevent="login"
    >
      <el-form-item prop="username" :label="useDesignV2 ? 'Логин' : null">
        <el-input
          v-model="model.username"
          :placeholder="useDesignV2 ? 'Введите логин' : 'Логин'"
          prefix-icon="fas fa-user"
          autocomplete="username"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" :label="useDesignV2 ? 'Пароль' : null">
        <el-input
          v-model="model.password"
          :placeholder="useDesignV2 ? 'Введите пароль' : 'Пароль'"
          type="password"
          prefix-icon="fas fa-lock"
          autocomplete="current-password"
          :show-password="useDesignV2"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          class="login-button"
          type="primary"
          native-type="submit"
          block
        >Войти
        </el-button>
      </el-form-item>
    </el-form>

<!--    <router-link-->
<!--      :to="{ name: 'Restore'}"-->
<!--    >-->
<!--      Забыли пароль?-->
<!--    </router-link>-->

  </div>
</template>

<script>


import requestSender from "@/api/base/requestSender";
import {authMethod} from "@/mixins/authMethod";
import {mapGetters} from "vuex";

export default {
  name: "login-pass",
  mixins: [authMethod],

  props: {
    // userId: {type: Number}
  },

  computed: {
    ...mapGetters('settings', ['useDesignV2']),
    rules() {
      if (!this.useDesignV2) {
        return {};
      }
      return {
        username: [{required: true, message: 'Введите логин', trigger: 'blur'}],
        password: [{required: true, message: 'Введите пароль', trigger: 'blur'}],
      };
    },
  },

  data() {
    return {
      loading: false,

      model: {
        username: '',
        password: '',
      },
    }
  },

  methods: {
    login() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.doLogin();
        }
      });
    },
    doLogin() {
      this.loading = true;
      requestSender('post', 'auth/login-pass/login', {
        username: this.model.username,
        password: this.model.password,
      })
        .then(data => {
          this.processAuthSuccess(data, 'loginPass');
          // localStorage.setItem('jwt', data.token);
          // localStorage.setItem('refresh_token', data.refresh_token);
          // localStorage.setItem('last_login_method', 'loginPass');
          //
          // this.$router.push({name: 'Home'});
        })
        .finally(() => {
          this.loading = false;
        })
    },

  }

}
</script>

<style>

</style>